import React from 'react'
import materialStyle from 'component/material/materialStyle'
import withStyles from '@material-ui/core/styles/withStyles'
import Box from '@material-ui/core/Box'
import cx from 'classnames'

const CustomBox = (props) => {
  const {className, classes, ...rest} = props

  return <Box {...rest} className={cx(className, classes.fullWidth)} />
}

export default withStyles(materialStyle)(CustomBox)
